import BuildAndQuoteModel from 'build-and-quote/models/BuildAndQuoteModel.js';
import * as buildAndQuoteTypes from 'build-and-quote/actions/buildAndQuoteActionTypes.js';

export default function buildAndQuoteReducer(state = new BuildAndQuoteModel(), action) {
    switch (action.type) {
        case buildAndQuoteTypes.CHANGE_BUILD_AND_QUOTE_SECTION:
            return state.set('buildAndQuoteSection', action.buildAndQuoteSection);

        case buildAndQuoteTypes.SET_MOBILE_PAYMENT_CALCULATOR_OPENED:
            return state.set('mobilePaymentCalculatorOpened', action.mobilePaymentCalculatorOpened);

        default:
            return state;
    }
}
